import { render } from "./Archiv.vue?vue&type=template&id=186b3dfa&scoped=true"
import script from "./Archiv.vue?vue&type=script&lang=js"
export * from "./Archiv.vue?vue&type=script&lang=js"

import "./Archiv.vue?vue&type=style&index=0&id=186b3dfa&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186b3dfa"]])

export default __exports__